import React from 'react';

class CloseIcon extends React.Component {
  render() {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.29289 7.70711L0 1.41421L1.41421 0L7.70711 6.29289L14 0L15.4142 1.41421L9.12132 7.70711L15.4142 14L14 15.4142L7.70711 9.12132L1.41421 15.4142L0 14L6.29289 7.70711Z"
          fill="#585A5D"
        />
      </svg>
    );
  }
}

export default CloseIcon;
